import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "caption mb-s2" }
const _hoisted_2 = { class: "p-input-icon-left w-full" }
const _hoisted_3 = {
  key: 0,
  class: "text-sm text-danger mt-s1"
}

import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import Icon from '@/components/icon/Icon.vue';
import { ethers } from 'ethers';


export default /*#__PURE__*/_defineComponent({
  __name: 'DestinationAddress',
  props: {
    modelValue: null,
    disabled: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'update:modelValue', value: string | null): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  modelValue: string;
  disabled?: boolean;
}




const { t } = useI18n();

const addressValue = ref(props.modelValue);
const showIncorrectAddress = ref(false);

const isValidAddress = computed(() => {
  return !addressValue.value || ethers.utils.isAddress(addressValue.value);
});

const onCheckAddress = () => {
  showIncorrectAddress.value = !isValidAddress.value;

  if (isValidAddress.value) {
    emits('update:modelValue', addressValue.value);
  } else {
    emits('update:modelValue', '');
  }
};

return (_ctx: any,_cache: any) => {
  const _component_InputText = _resolveComponent("InputText")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(t)('wrappedContract.destinationAddress')), 1),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_InputText, {
        modelValue: addressValue.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((addressValue).value = $event)),
        class: "w-full input-panel",
        placeholder: _unref(t)('wrappedContract.destinationAddressPlaceholder'),
        onChange: onCheckAddress
      }, null, 8, ["modelValue", "placeholder"]),
      _createVNode(Icon, {
        name: "wallet",
        class: "text-muted mr-s2",
        size: "20"
      })
    ]),
    (showIncorrectAddress.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, " Incorrect address. You should enter the EVM address in the format 0x... "))
      : _createCommentVNode("", true)
  ]))
}
}

})